import { render, staticRenderFns } from "./VolunteerPoolsStandard.vue?vue&type=template&id=4784464b"
import script from "./VolunteerPoolsStandard.vue?vue&type=script&lang=ts"
export * from "./VolunteerPoolsStandard.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerPoolsStandard.vue?vue&type=style&index=0&id=4784464b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports